import React, { useState } from 'react';
import { collection, addDoc } from 'firebase/firestore';
import { db } from '../../modules/auth/firebaseConfig';
import emailjs from 'emailjs-com';

export default function AddYourRoles() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    role: '',
    category: '',
  });

  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await addDoc(collection(db, 'role_requests'), {
        ...formData,
        createdAt: new Date().toISOString()
      });

      await emailjs.send(
        'your_service_id',
        'your_template_id',
        {
          to_name: formData.name,
          to_email: formData.email,
          message: `Hi ${formData.name},\n\nThanks for your role suggestion: ${formData.role}${formData.category ? ` under ${formData.category}` : ''}. Our team will review and get back to you.`
        },
        'your_user_id'
      );

      setSubmitted(true);
    } catch (error) {
      console.error('Error submitting role request:', error);
      alert('Submission failed. Please try again.');
    }
  };

  if (submitted) {
    return (
      <div className="text-center text-white p-8 bg-black min-h-screen">
        <h2 className="text-3xl font-bold mb-4">✅ Thank You!</h2>
        <p>Your role suggestion has been submitted. We’ll alert you after review.</p>
      </div>
    );
  }

  return (
    <div className="bg-black min-h-screen flex items-center justify-center px-4 text-white">
      <form
        onSubmit={handleSubmit}
        className="max-w-md w-full space-y-4 bg-gray-900 p-6 rounded-xl shadow-lg border border-gray-700"
      >
        <h2 className="text-xl font-bold mb-2">Request to Add Your Role</h2>
        <input
          type="text"
          name="name"
          placeholder="Your Name"
          required
          value={formData.name}
          onChange={handleChange}
          className="w-full p-3 rounded bg-gray-800 border border-gray-600"
        />
        <input
          type="email"
          name="email"
          placeholder="Your Email"
          required
          value={formData.email}
          onChange={handleChange}
          className="w-full p-3 rounded bg-gray-800 border border-gray-600"
        />
        <input
          type="text"
          name="role"
          placeholder="Requested Role"
          required
          value={formData.role}
          onChange={handleChange}
          className="w-full p-3 rounded bg-gray-800 border border-gray-600"
        />
        <input
          type="text"
          name="category"
          placeholder="(Optional) Category"
          value={formData.category}
          onChange={handleChange}
          className="w-full p-3 rounded bg-gray-800 border border-gray-600"
        />
        <button
          type="submit"
          className="w-full py-3 bg-blue-600 hover:bg-blue-700 rounded font-semibold text-white"
        >
          📩 Submit Request
        </button>
      </form>
    </div>
  );
}
